import { render, staticRenderFns } from "./riskConfig.vue?vue&type=template&id=05f7b8a6&scoped=true"
import script from "./riskConfig.vue?vue&type=script&lang=js"
export * from "./riskConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f7b8a6",
  null
  
)

export default component.exports